import { trackPromise } from "react-promise-tracker";
import servers from "./servers";

class API {
  constructor() {
    this.controller = new AbortController();
  }

  call = async ({ cmd, path = "", payload }) => {
    const { url: baseUrl, method, mode } = servers[cmd];
    const url = path ? baseUrl + "/" + path : baseUrl;

    if (mode && mode === "blob") {
      const { url, type } = payload;

      const res = await trackPromise(fetch(url));
      const blob = await res.blob();

      return blob();
    }
    const config = { method, mode: "cors", signal: this.controller.signal };
    if (method === "GET") {
      config.headers = { "Content-Type": "application/json" };
    }
    if (method === "POST") {
      if (mode === "form") {
        config.body = payload;
      } else {
        config.headers = { "Content-Type": "application/json" };
        config.body = JSON.stringify(payload);
      }
    }
    console.log(url, config, cmd, payload);
    const res = await trackPromise(fetch(url, config));
    try {
      return await res.json();
    } catch (err) {
      return {
        statusCode: 500,
        message: "Oops! Something went wrong while fetching.",
        originalError: err,
      };
    }
  };
}

export default API;
